import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategoryGrid />
        <HotArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}